export default class FinesseDescription extends HTMLElement {
  list: HTMLElement | null = null
  buttons: NodeList | any // HTMLCollection | null = null

  description: HTMLElement | any = this.querySelector('div[data-description]')
  details: HTMLElement | null = this.querySelector('div[data-details-content]')

  tabs: NodeList | any = this.querySelectorAll('button')
  tabContents: NodeList | any = this.querySelectorAll('div[data-tab-content]')

  connectedCallback() {
    const shortDescription = this.querySelectorAll('.short-description')
    const fullDescription = this.querySelectorAll('.full-description')

    if (this.description) {
      this.description.innerHTML = ''
      Array.from(shortDescription).forEach((description: HTMLElement | any) => {
        this.description.append(description)
      })

      this.description.classList.remove('hidden')
    }

    if (this.details) {
      Array.from(fullDescription).forEach((description: HTMLElement | any) => {
        this?.details?.append(description)
      })
    }

    this.buttons = this.querySelectorAll('button')

    Array.from(this.buttons).forEach((button: HTMLElement | any) => {
      button.addEventListener('click', this.handleButtonClick)
    })

    this.handleButtonClick = this.handleButtonClick.bind(this)
  }

  handleButtonClick = (evt: Event) => {
    const button = evt.target as HTMLElement

    const active = button.getAttribute('data-active') === 'true'
    const content = button.nextElementSibling as HTMLElement

    if (active) {
      button.setAttribute('data-active', 'false')
      button.classList.remove("after:content-['-']")
      button.classList.add("after:content-['+']")
      content.classList.add('hidden')
    } else {
      button.setAttribute('data-active', 'true')
      button.classList.remove("after:content-['+']")
      button.classList.add("after:content-['-']")
      content.classList.remove('hidden')
    }
  }
}

customElements.define('finesse-description', FinesseDescription)
